import { ConfigurationData } from 'src/models/Configuration'
import { get } from './axios'

//////////////////////////////////////////////////////////////////////
// Get
//////////////////////////////////////////////////////////////////////

/**
 * getConfigurations
 */

export const getConfigurations = async () => {
  return await get<ConfigurationData>(`/v1/configurations`, {}, false)
}
